import {actions as ACTION, mutations as MUTATION} from "./types";
import {Api, ApiUrl} from "../../services";
export const transformPageNameToHandleType = originalType => {
  switch (originalType) {
    case "Complete Store":
      return "complete-store";
    case "Landing Page":
      return "template-page";
    case "Product Page":
      return "template-product";
    case "Home Page":
      return "template-index";
    case "Collection Page":
      return "template-collection";
    case "Blog Post":
      return "template-article";
    default:
      return null;
  }
};

const actions = {
  [ACTION.GO_TO_STEP]: (store, payload) => {
    store.commit(MUTATION.DO_GO_TO_STEP, payload);
  },
  [ACTION.CLOSE_WIDGET_ON_BOARDING]: (store) => {
    store.commit(MUTATION.DO_CLOSE_WIDGET_ON_BOARDING);
  },
  [ACTION.OPEN_WIDGET_ON_BOARDING]: (store) => {
    store.commit(MUTATION.DO_OPEN_WIDGET_ON_BOARDING);
  },
  [ACTION.UPDATE_JOB_ROLE]: (store, payload) => {
    store.commit(MUTATION.DO_UPDATE_JOB_ROLE, payload);
  },
  [ACTION.UPDATE_BUSINESS_TYPE]: (store, payload) => {
    store.commit(MUTATION.D0_UPDATE_BUSINESS_TYPE, payload);
  },
  [ACTION.LAST_STEP_SUBMIT]: (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {state} = store;
        const jobRole = state.widget.data.jobRole.type;
        const jobRoleValue = state.widget.data.jobRole.value;
        const jobValue = jobRole === "other" ? jobRoleValue : jobRole;
        const businessType = state.widget.data.businessType;

        const params = {
          "surveyHandle": "dashboard-widget-survey",
          "data": {
            jobRole: jobValue,
            businessType: businessType
          },
          "status": "done"
        };
        const res = await Api.base.post(ApiUrl.base.newonboarding.widgetSurvey, params);
        // const res = {message: "success"};
        if (res.data && res.data.message == "success") {
          store.commit(MUTATION.DO_GO_TO_STEP, {step: 4});
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    })
  },
  [ACTION.UPDATE_IS_SUBMIT_STEP]: (store, payload) => {
    store.commit(MUTATION.DO_UPDATE_IS_SUBMIT_STEP, payload);
  },
  [ACTION.UPDATE_SUBMITTING_STATUS]: (store, payload) => {
    store.commit(MUTATION.DO_UPDATE_SUBMITTING_STATUS, payload);
  },
  [ACTION.UPDATE_JOB_ROLE_VALUE]: (store, payload) => {
    store.commit(MUTATION.DO_UPDATE_JOB_ROLE_VALUE, payload);
  },
  [ACTION.UPDATE_SURVEY_ONBOARDING]: (store, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        const params = {
          "surveyHandle": "onboarding-v2",
          "data": {
            "pageType": payload.pageType ? payload.pageType : "",
            "industry": payload.industry ? payload.industry : [],
            "skipped": payload?.skipped ?? false,
          },
          "status": "done"
        };
        const res = await Api.base.post(ApiUrl.base.newonboarding.widgetSurvey, params);
        resolve(res)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    })
  },
}

export default actions;
